<div class="counter-flex">
  <input type="text" #input
    [style.overflow-y]="setVerticalScrollPolicy()" [tabindex]="tabEnabled ? tabindex : -1"
    [disabled]="disabled" [readonly]="!editable" [maxlength]="maxChars" [(ngModel)]="text" autocomplete="off"
    (ngModelChange)="textChanged(); onChange($event);" plessInputTextSub [restrict]="restrict" [fullOnly]="fullOnly" [halfOnly]="halfOnly"
    [toUpperCase]="toUpperCase" [allowMultiLine]="allowMultiLine"
    [style.width]="width !== undefined ? width : '100%'"
    (blur)="onTouched(); blur.emit($event);" (focus)="focus.emit($event);">
  <label class="count-field" *ngIf="displayCountField" [style.width]="counterWidth">{{ count }}</label>
</div>
